var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WeBlockTypes',{staticClass:"mb-3",attrs:{"value":_vm.blocks},on:{"create-block":_vm.onCreateBlock}}),_c('WePageContent',{attrs:{"blocks":_vm.blocks},on:{"update:blocks":function($event){_vm.blocks=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }